export const firebaseConfig = {
    apiKey: "AIzaSyAkWRXfBae8UONb0mb1tO3kyUCBhX8Y_GI",
    authDomain: "cgis-urban-pleiku.firebaseapp.com",
    projectId: "cgis-urban-pleiku",
    storageBucket: "cgis-urban-pleiku.appspot.com",
    messagingSenderId: "905178348739",
    appId: "1:905178348739:web:fce5167c29bda49a1eb676",
    measurementId: "G-CEYQESZVXW"
};  